import request from '@/utils/request';
/* 实名认证-获取实名认证配置 */
export const getRealNameAuth = (): Promise<any> =>
  request({
    url: '/api/v1/omc/system_common_setting/real_name_auth',
    method: 'get',
  });
/* 【系统管理】实名认证-配置实名认证 */
export const setRealNameAuth = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/system_common_setting/real_name_auth',
    method: 'put',
    data,
  });
